import * as React from "react"
import { ThemeProvider, createTheme } from "@mui/material/styles"
import CssBaseline from "@mui/material/CssBaseline"
import { useAppSelector } from "../hooks"
import { baseUrl } from "../../shared/api/baseQuery"

declare module "@mui/material/styles" {
  interface BreakpointOverrides {
    mobile: true
  }
}

export const withTheme = (Component: React.ComponentType) => () => {
  const state = useAppSelector((state) => state.theme)
  const theme = createTheme({
    breakpoints: {
      values: {
        xs: 0,
        mobile: 400,
        sm: 600,
        md: 900,
        lg: 1296,
        xl: 1536,
      },
    },
    palette: {
      primary: {
        main: "rgba(27, 156, 24, 1)",
      },
      warning: {
        main: "rgba(243, 196, 26, 1)",
      },

      mode: state.mode,
      ...(state.mode === "light"
        ? {
            background: {
              default: "#EBEBEB",
              paper: "#FAFAFA",
            },
          }
        : {
            background: {
              paper: "#272626",
            },
          }),
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          html: {
            scrollbarColor: "#D9D9D9",
            "&::-webkit-scrollbar, & *::-webkit-scrollbar": {
              backgroundColor: "#EBEBEB",
            },
            "*::-webkit-scrollbar": {
              height: "10px",
              width: "10px",
            },
            "&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb": {
              borderRadius: 8,
              backgroundColor: "#D9D9D9",
              border: "1px solid #DEDEDE",
            },
            "&::-webkit-scrollbar-thumb:focus, & *::-webkit-scrollbar-thumb:focus":
              {
                backgroundColor: "#B9B9B9",
              },
            "&::-webkit-scrollbar-thumb:active, & *::-webkit-scrollbar-thumb:active":
              {
                backgroundColor: "#B9B9B9",
              },
            "&::-webkit-scrollbar-thumb:hover, & *::-webkit-scrollbar-thumb:hover":
              {
                backgroundColor: "#B9B9B9",
              },
            "&::-webkit-scrollbar-corner, & *::-webkit-scrollbar-corner": {
              backgroundColor: "#EBEBEB",
            },
          },
        },
      },

      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: "none",
          },
          contained: {
            boxShadow: "none",
            ":hover": { boxShadow: "none" },
          },
        },
      },
      MuiTableCell: {
        styleOverrides: {
          root: {
            borderBottom: "none",
            padding: "10px",
          },
        },
      },
      MuiTableRow: {
        styleOverrides: {
          root: {
            "&:hover": {
              backgroundColor: "rgb(27,156,24,0.1) !important",
            },
          },
        },
      },
      MuiTooltip: {
        styleOverrides: {
          tooltip: {
            backgroundColor: "white",
            color: "black",
            border: "1px solid #1B9C18",
          },
          arrow: {
            "&:before": {
              border: "1px solid #1B9C18",
            },

            color: "white",
          },
        },
      },
      MuiDialog: {
        styleOverrides: {
          paper: {
            backgroundColor: "#FAFAFA",
          },
        },
      },
      MuiPopover: {
        styleOverrides: {
          paper: {
            backgroundColor: "#FAFAFA",
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            backgroundColor: "#FAFAFA",
          },
        },
      },
    },
  })
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline enableColorScheme />
      <Component />
    </ThemeProvider>
  )
}
